var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg6996",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7000"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath7010"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path7008"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g7002",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7006",
    clipPath: "url(#clipPath7010)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7012",
    transform: "translate(233.5,184.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -211 c -8.25,0 -15,6.75 -15,15 v 112.5 c 0,8.25 6.75,15 15,15 h 467 c 8.25,0 15,-6.751 15,-15 V 15 C 271,6.75 264.249,0 256,0 H 45 M 30,0 H 15",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7014"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7016",
    transform: "translate(44.2114,327.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -1.471,51.875 58.523,31.611 31.611,58.523 66.488,-1.885 56.638,34.876 56.637,-34.876 66.488,1.885 L 366.525,83.486 425.047,51.875 423.578,0 m 0,-142.5 1.469,-51.875 -58.522,-31.611 -31.611,-58.523 -66.488,1.885 -56.637,-34.876 -56.638,34.876 -66.488,-1.885 -31.611,58.523 -58.523,31.611 L 0,-142.5",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7018"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7020",
    transform: "translate(163.4575,410.4092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 27.041,16.245 58.699,25.591 92.542,25.591 74.1,0 137.732,-44.78 165.336,-108.75 m -330.671,0 c 12.986,30.096 33.949,55.941 60.222,74.877 m 270.449,-217.377 c -27.604,-63.971 -91.236,-108.75 -165.336,-108.75 -74.099,0 -137.731,44.779 -165.335,108.75",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7022"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7024",
    transform: "translate(338.499,368.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 15 m -30,10e-4 v 15",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2.613,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7026"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7028",
    transform: "translate(224.7354,226.4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 22.807,59.884 25.355,59.887 47.955,0",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7030"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7032",
    transform: "translate(231.8481,241.3418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 33.843",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7034"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7036",
    transform: "translate(319.5703,225.6885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 60.626 L 2.664,60.625 40.17,0.936 h 2.665 v 59.803",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7038"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7040",
    transform: "translate(447.1035,256.957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-16.24 -9.014,-29.221 -23.314,-29.472 h -17.182 v 58.943 h 16.693 C -8.117,29.471 0,16.241 0,0 Z",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7042"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7044",
    transform: "translate(67.896,258.3418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 17.725 c 9.029,0 16.349,-7.319 16.349,-16.349 0,-9.029 -7.32,-16.422 -16.349,-16.422 H -3 v 60.74 h 17.643 c 7.719,0 13.977,-6.257 13.977,-13.976 C 28.62,6.273 22.363,0 14.644,0",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7046"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7048",
    transform: "translate(157.1504,250.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 20.016,-23.661",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7050"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7052",
    transform: "translate(149.3042,254.6699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 13.028,0.07 c 9.034,0 16.679,7.068 16.679,15.785 0,8.718 -7.645,15.786 -16.679,15.786 h -16.15 l -0.01,-60.74",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path7054"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrands);
export default __webpack_public_path__ + "static/media/brands.037ab8df5c2ba1c0ed2b4735a18ef55f.svg";
export { ForwardRef as ReactComponent };